import { createFileRoute } from "@tanstack/react-router";
import { ErrorAlert } from "@/components/ui";
import { ContabilizacionPasoPage } from "@/features/contabilizacion/components/ContabilizacionPasoPage";
import { solicitudQueryOptions } from "@/features/solicitudes/hooks/use-solicitud";

export const Route = createFileRoute("/_authed-tw/solicitudes/$id/contabilizacion")({
  loader: ({ context: { queryClient }, params: { id } }) =>
    queryClient.ensureQueryData(solicitudQueryOptions(id)),
  component: ContabilizacionPasoPage,
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
